// Helpers for showing a part of the page once, when what it shows is ready, instead of piece by piece.

// The interface faces used on first paint. Text shown before they load would reflow when they arrive.
const INTERFACE_FACES = ['400 1em "SF Pro Text"', '500 1em "SF Pro Text"', '600 1em "SF Pro Text"'];

let fontsReady;

export const whenFontsReady = () => {
	if (!fontsReady) {
		fontsReady = typeof document !== 'undefined' && document.fonts?.load
			? Promise.all(INTERFACE_FACES.map((face) => document.fonts.load(face))).catch(() => {})
			: Promise.resolve();
	}
	return fontsReady;
};

// Resolves once every task has settled, or after `ms`, whichever comes first.
export const settleWithin = (tasks, ms) => new Promise((resolve) => {
	const timer = setTimeout(resolve, ms);
	Promise.allSettled(tasks).then(() => {
		clearTimeout(timer);
		resolve();
	});
});

// Resolves when the image is downloaded and decoded, so it can appear in one frame.
export const decodeImage = (url) => {
	if (typeof Image === 'undefined') return Promise.resolve();
	const image = new Image();
	image.src = url;
	return typeof image.decode === 'function' ? image.decode().catch(() => {}) : Promise.resolve();
};
